import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1759d13c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "feature-con" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Checking Round", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "BU", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Status", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "search-button" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_13 = { class: "table-button" }
const _hoisted_14 = { class: "functionality-button" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Reject")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Approve")
const _hoisted_17 = { class: "table" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "table-pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { dataSource: [] }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_space, { size: "middle" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_4,
                _hoisted_5,
                _createVNode(_component_a_select, {
                  allowClear: "",
                  value: _ctx.checkingRoundVal,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkingRoundVal) = $event)),
                  placeholder: "Please select",
                  class: "sel-inp-size"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkingRoundArray, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.key,
                        value: item.key
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.value), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _createElementVNode("div", null, [
                _hoisted_6,
                _hoisted_7,
                _createVNode(_component_a_select, {
                  allowClear: "",
                  value: _ctx.BUVal,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.BUVal) = $event)),
                  placeholder: "Please select",
                  class: "sel-inp-size"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buArray, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.id,
                        value: item.nameEn
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.nameEn), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _createElementVNode("div", null, [
                _hoisted_8,
                _hoisted_9,
                _createVNode(_component_a_select, {
                  value: _ctx.statusVal,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.statusVal) = $event)),
                  placeholder: "Please select",
                  class: "sel-inp-size"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkingRoundStatusArray, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.key,
                        value: item.key
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.value), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.$btnPermissions('ACP-01'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  style: {"height":"32px","width":"76px","margin-top":"10px"},
                  onClick: _ctx.searchTable,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.$btnPermissions('ACP-02'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  style: {"height":"32px","width":"76px","margin-top":"10px","margin-left":"10px"},
                  onClick: _ctx.resetTableData
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_a_space, { size: "middle" }, {
            default: _withCtx(() => [
              (_ctx.$btnPermissions('ACP-03'))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    onClick: _ctx.rejectCheckingPlan
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('ACP-04'))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    onClick: _ctx.approveCheckingPlan,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_a_table, {
            class: "ant-table-striped",
            rowKey: (item, index) => item.id,
            "row-selection": { selectedRowKeys: _ctx.selectedRowKeys, onChange: _ctx.onSelectChange },
            rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null),
            pagination: false,
            scroll: { y: _ctx.tableHeight },
            dataSource: _ctx.dataSource,
            columns: _ctx.columns
          }, {
            operation: _withCtx(({ record }) => [
              (_ctx.$btnPermissions('ACP-05'))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "export",
                    onClick: ($event: any) => (_ctx.exportTable(record))
                  }, "Export", 8, _hoisted_18))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["rowKey", "row-selection", "rowClassName", "scroll", "dataSource", "columns"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_a_pagination, {
        total: _ctx.total,
        "show-total": (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        "page-size": 20,
        onChange: _cache[3] || (_cache[3] = (page, pageSize) =>_ctx.pageChange(page)),
        onShowSizeChange: _cache[4] || (_cache[4] = (page, pageSize) =>_ctx.sizeChange(page, pageSize)),
        "show-size-changer": "",
        current: _ctx.currentPage,
        pageSize: _ctx.pageSize,
        pageSizeOptions: ['10', '20', '30', '40', '50']
      }, null, 8, ["total", "show-total", "current", "pageSize"])
    ])
  ], 64))
}